import React from "react";

import styles from "./EducationHeader.css";

export default function EducationHeader() {
  return (
    <div className={styles.root}>
      <p className={styles.text}>
        <img
          src={require("assets/img/bill-and-melinda-gates-foundation.png")}
          alt="Education coverage brought to you by the Bill and Melinda Gates Foundation."
        />
        Education coverage brought to you by the{" "}
        <a
          href="http://k12education.gatesfoundation.org/nsiyear1/"
          target="_blank"
          rel="noopener"
        >
          Bill and Melinda Gates Foundation
        </a>
        .
      </p>
    </div>
  );
}
